

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 56 56"}, rest), [h('g', {"fill":"none","fill-rule":"evenodd"}, [h('rect', {"width":"56","height":"56","fill":"#6259d7","fill-rule":"nonzero","rx":"8"}, []), h('path', {"fill":"var(--white)","d":"M33 17.25c2.42 0 3.75 1.33 3.75 3.75l.001.903c1.474.78 1.999 2.337 1.999 5.097v6c0 4.41-1.34 5.75-5.75 5.75H23c-4.41 0-5.75-1.34-5.75-5.75V23c0-4.41 1.34-5.75 5.75-5.75h10Zm-14.249 5.521L18.75 33c0 3.57.67 4.25 4.25 4.25h10c3.58 0 4.25-.68 4.25-4.25v-6c0-2.308-.28-3.408-1.446-3.898a.669.669 0 0 1-.133-.05c-.586-.213-1.378-.292-2.442-.301L30 22.75c-1.28 0-1.7-.44-2.2-1.1l-1.5-2c-.52-.69-.68-.9-1.8-.9H23c-3.502 0-4.22.65-4.249 4.021ZM29 20.75c.33.44.38.5 1 .5h3c.863 0 1.61.051 2.25.167V21c0-1.58-.67-2.25-2.25-2.25h-5.5l1.5 2Z"}, [])])]);
};

        